<template>
  <div class="nav">
    <div class="title" :class="{border: border}">
      <!-- <span class="iconfont iconfanhui back_icon" @click="back"></span> -->
      <span class='back_icon' @click="back">
        <base-icon icon='iconfanhui' />
      </span>
      <span>{{title}}</span>
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "标题"
    },

    border: {  // 是否有boder底线
      type: Boolean,
      default: true
    }
  },

  methods: {
    back() {
      this.$router.back(-1)
   }
  }
};
</script>

<style lang='scss' scoped>
.nav {
  // position: fixed;
  // top: 0;
  width: 100%;
  background: #FFFFFF;
  z-index: 10;

  .title {
    position: relative;
    height: 50px;
    text-align: center;
    line-height: 50px;
    font-size: 16px;
    font-weight: bolder;
    color: #333333;
    // box-shadow: 0 2px 4px 0 rgba(0,0,0,0.06);

    .back_icon {
      position: absolute;
      left: 0;
      height: 100%;
      padding-left: 10px;
      padding-right: 16px;

      &:active {
        background-color: rgba(0, 0, 0, 0.1);
      }
    }
  }

  .border {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

}
</style>